/**
 * O que o tour preenche sozinho no ensaio (ADR 041).
 *
 * O ensaio responde de um banco de mentira, mas o texto que se cola precisa
 * passar pelo mesmo validador do app — então é um lote de verdade, de **um**
 * item tirado do exemplo do próprio app. Um basta para mostrar a questão, a
 * volta e o fim da sessão; com mais, o tour virava responder a sessão inteira.
 */

export const TRILHA_DO_ENSAIO = "Banco de Dados";

export const ASSUNTO_DO_ENSAIO = "formas normais: 1FN, 2FN, 3FN e BCNF";

export const LOTE_DO_ENSAIO = JSON.stringify({
  "versao": 1,
  "trilha": "Banco de Dados",
  "lote": "exemplo-do-tour",
  "fonte": "exemplo do tour do Grifo",
  "itens": [
    {
      "id": 1,
      "categoria": [
        "Modelagem",
        "Normalização"
      ],
      "tipo": "multipla",
      "dificuldade": "Fácil",
      "enunciado": "Uma tabela está na primeira forma normal (1FN) quando:",
      "conteudo": {
        "alternativas": {
          "A": "Todos os atributos são atômicos e não há grupos de valores repetidos numa mesma coluna.",
          "B": "Nenhum atributo não-chave depende apenas de parte da chave primária.",
          "C": "Não existe dependência transitiva entre atributos não-chave.",
          "D": "Todo determinante da tabela é uma superchave.",
          "E": "A tabela possui ao menos uma chave estrangeira declarada."
        }
      },
      "gabarito": {
        "correta": "A"
      },
      "explicacao": "A 1FN trata do formato do dado, não das dependências. Ela exige valores atômicos: nada de \"São Paulo, Rio de Janeiro\" numa coluna só, nada de colunas telefone1, telefone2, telefone3 fazendo as vezes de lista.\n\nAs outras alternativas são as formas seguintes, e é útil guardar a escada inteira: B é a 2FN (dependência parcial), C é a 3FN (dependência transitiva) e D é a forma de Boyce-Codd. A alternativa E não é forma normal nenhuma — chave estrangeira é integridade referencial, assunto vizinho e diferente."
    }
  ]
}, null, 2);
